import React from 'react'
import { Link } from "react-router-dom"

const Dos = () => {
    return(
        <div>
            <div style={{border: 'solid rgba(229, 227, 210)'}}></div>
            <h1>Plan for fadderuka</h1>
            <h4>Publisert: 01.07.2021, sist oppdatert: 17.08.2021</h4>
            <p>Hei, da er det klart for fadderuke! Under ligger tidsplan for opplegget de neste tre dagene. Vi blir fire faddergrupper, og vi fordeler fadderbarn på onsdag rett etter velkomstmøtet.</p>
            <p>Faddere møter opp onsdag mellom kl 10:30 og senest kl 11:00 utenfor Logo. Vi kan hente røde tskjorter i 3. etasje.</p>
            <p><a href="https://www.mn.uio.no/ifi/studier/master/studiestart/">Her er linken til UiO sin offisielle studiestart side som blir sendt ut til de nye studentene. </a></p>
            <br/>
            <div className="table">
                <div className="table">
                    <h2>Onsdag 18. August</h2>
                    <p>kl. 09:15-11:00 ----  Nye masterstudenter har velkomstmøte på Logo.</p>
                    <p>kl. 11:00-11:30 ----  Felles lunsj og vi deler inn i faddergrupper.</p>
                    <p>kl. 11:30-14:00 ----  <Link to={"/rebus"}>"Omvisningschallenge" på ifi & blindern.</Link></p>
                    <p>kl. 14:15-15:00 ----  Erfaringsdeling fra 5.klassinger om høstfagene.</p>
                    <p>kl. 16:00-19:00 ----  Pause</p>
                    <p>kl. 19:00-00:00 ----  De som vil drar til et utested.</p>
                </div>
                <div className="table">
                <h2>Torsdag 19. August</h2>
                    <p>Denne dagen er det frist for emnepåmelding!</p>
                    <p>kl. 14:15-15:00 ----  Spørretime på zoom m/ admin, 5. klassinger får eget breakout rom fra 14:30 og utover for å svare på spørsmål.</p>
                    <p>kl. 16:00-19:00 ----  Utflukt til Oslo camping! Instituttet dekker et gratis spill.</p>
                    <p>kl. 19:00-20:00 ----  Oslo Streetfood</p>
                    <p>kl. 20:00-00:00 ----  De som vil drar til et utested.</p>
                </div>
                <div className="table">
                <h2>Fredag 20. August</h2>
                    <p>kl. 09:15-14:00 ----  Nye masterstudenter har zoom seminar.</p>
                    <p>kl. 15:00-19:00 ----  <a href="https://fb.me/e/4xcaEBmV8"> Grill & chill på Sognsvann med alle ifi masterlinjene!</a></p>
                    <p>kl. 20:00-00:00 ----  Mulighet for å dra videre til et utested for de som vil.</p>
                </div>  
            </div>
            <br/>
            <p>Bare å sende meg en melding på fb, mobil (99098900), eller mail (siljemfl@ifi.uio.no) om det er noe du lurer på! </p>
            <p>- Silje Marie Flaaten</p>
        </div>
    )
}

export default Dos